/**
 * @generated SignedSource<<57a16b90f64afe60d1f52d9f23612d94>>
 * @relayHash b11afb30be2aadf3eafbc0f932ebe4c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 40b5587bacabae951a89e8aa7ff512d159148cedb06a86b0223040b0cad4aaca

import type { ConcreteRequest } from 'relay-runtime';
export type activationResourceQuery$variables = {
  cloudId: string;
  isEnabled: boolean;
};
export type activationResourceQuery$data = {
  readonly tenantContexts?: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly active: string | null;
    } | null;
  } | null> | null;
};
export type activationResourceQuery = {
  response: activationResourceQuery$data;
  variables: activationResourceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "condition": "isEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "items": [
              {
                "kind": "Variable",
                "name": "cloudIds.0",
                "variableName": "cloudId"
              }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
          }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "product",
                "value": "rovo"
              }
            ],
            "concreteType": "TenantContextActivationId",
            "kind": "LinkedField",
            "name": "activationIdByProduct",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "active"
              }
            ],
            "storageKey": "activationIdByProduct(product:\"rovo\")"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "activationResourceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "activationResourceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "40b5587bacabae951a89e8aa7ff512d159148cedb06a86b0223040b0cad4aaca",
    "metadata": {},
    "name": "activationResourceQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e416535db25a480e070e130084867f39";

export default node;
